import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';
import { TaxTransactionSyncInfo } from '../fragments';

export default gql`
  mutation ActionReplayTaxTransactionSync(
    $input: TaxTransactionSyncReplayActionInput!
  ) {
    actionTaxTransactionSyncReplay(input: $input) {
      clientMutationId
      enqueued
      errorMessages {
        ...ErrorMessageInfo
      }
      sync {
        ...TaxTransactionSyncInfo
      }
    }
  }
  ${ErrorMessageInfo}
  ${TaxTransactionSyncInfo}
`;
